import { Outlet } from "react-router-dom";

import TopBar from "components/layout/navbar/TopBar";

const FleetLayout = ({ title = "Fleet" }) => {
    return (
        <div className="layout pl-20">
            <TopBar title={title} />
            <Outlet context={[title]} />
        </div>
    );
};

export default FleetLayout;
